// Import Material UI
import {CircularProgress, Dialog, DialogContent, DialogTitle, Tooltip} from "@material-ui/core"
import { Close } from "@material-ui/icons"


// Import Packages
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// Import Pages
import FullScreen from "../../../../components/FullScreen/FullScreen";
import LogInfoDetails from "./LogInfoDetails";

// Import Icons
import emptyPageIcon from '../../../../assets/icons/configurationIcons/empty-page.svg';
import actionInfoIcon from '../../../../assets/icons/configurationIcons/monitoring-action-info-icon.svg';
import actionErrorIcon from '../../../../assets/icons/configurationIcons/monitoring-action-error-icon.svg';
import automEndIcon from "../../../../assets/icons/configurationIcons/autom-end-log-icon.svg";
import logQuickInfoIcon from "../../../../assets/icons/configurationIcons/log-quick-info-icon.svg";
import LogWebhookIcon from '../../../../assets/icons/configurationIcons/Log-webhook-icon.svg';

// Import Recoil
import {useRecoilValue, useSetRecoilState} from "recoil";
import {alertState, personalizationState} from "../../../../recoil-store/recoil-state";

// Import CSS
import "./OperationLogs.css";
import {
    convertToDateFormat,
    showPreviewData,
    isJSONParsable
} from "../../../../helpers/helper";
import OperationService from "../../../../services/OperationService/OperationService";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";

import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import LogWarningIcon from "../../../../assets/icons/configurationIcons/Log-warning-icon.svg";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import convertDateToTimestamp
    from "../../../../components/FlowConfigurationForms/Date/ConvertDateToTimestamp/ConvertDateToTimestamp";

export const AllProgressOperationLogs = ({ data, setOpenActivityLog, setSelectedOperation, ehLog, ehGroupId, summaryLog }) => {
    const { t } = useTranslation();
    const [operationData, setOperationData] = useState({})
    const [isNewLogs, setIsNewLogs] = useState(false)
    const [loading, setLoading] = useState(false)
    const [tab, setTab] = useState("Root");
    const [type, setType] = useState("input");
    const [fullScreenValue, setFullScreenValue] = useState({ type: "", value: "" });
    const [selectedGroupLog, setSelectedGroupLog] = useState({})
    const [selectedLog, setSelectedLog] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [openEhLogs, setOpenEhLogs] = useState(false);
    const resultRefs = useRef([]);
    const personalization = useRecoilValue(personalizationState);
    const setAlert = useSetRecoilState(alertState);
    const open = Boolean(anchorEl);

    const label = "MESSAGES.MONITORING."

    const handleClose = () => {
        setOpenActivityLog(false)
    }

    useEffect(() => {
        fetchData()
    }, [data]);
    useEffect(() => {
        setType("input")
    }, [selectedLog]);

    useEffect(() => {
        if (resultRefs.current[highlightedIndex]) {
            resultRefs.current[highlightedIndex].scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
        if (resultRefs?.current[highlightedIndex]) {
            resultRefs.current[highlightedIndex].style.backgroundColor = "orange"
        }
    }, [highlightedIndex]);

    const fetchData = () => {
        const startDate = new Date();
        const endDate = new Date();
        endDate.setDate(endDate.getDate() - 1);
        endDate.setHours(startDate.getHours());

        setLoading(true);
        OperationService.getOperationTriggerData(`?operation_id=${data.operation_id}`)
            .then((response) => {
                if (response && response.data && response.code === 200) {
                    response.data.trigger_data = response.data.trigger_data && isJSONParsable(response.data.trigger_data) ? response.data.trigger_data : {}
                    response.data.trigger_header = response.data.trigger_header && isJSONParsable(response.data.trigger_header) ? response.data.trigger_header : {}
                    setOperationData(response.data)
                    setIsNewLogs(true)
                } else {
                    setIsNewLogs(false)
                }

                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }

    const handleShowQuickInfo = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleHideQuickInfo = (e) => {
        setAnchorEl(null);
    };

    const handleOpenInfoArea = (item) => {
        setSelectedLog(item);
    };

    const findLogIcon = (tag) => {
        switch (tag) {
            case "INFO":
                return actionInfoIcon
            case "ERROR":
                return actionErrorIcon
            default:
                return actionInfoIcon
        }
    };

    const handleCopyInputAndOutput = async (e, text) => {
        try {
            await navigator.clipboard.writeText(text);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + `COPIED`),
                severity: 'success'
            }));
            e.preventDefault()
            e.stopPropagation()
        } catch (err) {
        }
    };

    return (
        <Dialog
            id="all-operation-log-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            PaperProps={{
                style: {
                    maxWidth: "95%",
                    width: Object.keys(selectedLog).length && isNewLogs ? "80%" : "50%",
                    height: "100%",
                    borderRadius: " 4px",
                    padding: "0",
                    background: "transparent",
                    flexDirection: "row",
                    gap: "20px",
                    overflow: "hidden"
                },
            }}
        >
            <div className="all-operation-log-side-container" style={{ width: Object.keys(selectedLog).length && isNewLogs ? "60%" : "100%", padding: Object.keys(selectedLog).length && isNewLogs ? "0" : "4px 22px" }}>
                <DialogTitle id="alert-dialog-title">
                    <div id="about-title" className="add-group-header all-logs-header">
                        <div>
                            <h4 className="autom-name-title">{t(label + (ehLog ? "ERROR-HANDLING-FLOW-LOGS" : "ALL-LOGS"))}</h4>
                            <small
                                className="conf-field-desc"><em>{t(label + (ehLog ? "ERROR-HANDLING-FLOW-LOGS-DESCRIPTION" : "ALL-LOGS-DESCRIPTION"))}</em></small>
                        </div>
                        <Close className="autom-group-close-button logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
                    </div>
                </DialogTitle>
                <DialogContent className="log-detail-container all-log-detail-container" style={{ height: "78%" }}>
                    {loading ? <div className='db-create-loading-page'><CircularProgress /></div>
                        : operationData.trigger_data && isNewLogs ?
                            <>
                                <div className={`log-row-container bigger-row all-log-groupable-container`}>
                                    <div className='log-started-ended-row'>
                                        <div className='group-column'>
                                            <PlayCircleFilledWhiteIcon color='red' className='log-action-image'/>
                                            <p className='log-action-name'>{t(label + "AUTOM-STARTED")}</p>
                                        </div>
                                        <p className='time-of-log'>{operationData?.created_at ? convertToDateFormat(operationData?.created_at, personalization.date_format) : "-"}</p>
                                    </div>
                                </div>
                                <div
                                    className={`log-row-container info`}
                                    style={{boxShadow: "0px 0px 4px 0px #00000040"}}>
                                    <div className="log-row">
                                        <div className='group-column'>
                                            <span className='index-number'>1.</span>
                                            <div
                                                className={`log-level-column log-info`}>{t(label + `INFO`).toUpperCase()}</div>
                                            <img className='log-action-image' src={LogWebhookIcon} alt='trigger-param-icon'/>
                                            <p className='log-action-name'>
                                                {t(label + "TRIGGER-PARAM")}
                                            </p>
                                        </div>
                                        <div className='all-logs-log-action-container'>
                                            <img alt="log-quick-info-icon" className='all-logs-quick-info-icon'
                                                 src={logQuickInfoIcon} onClick={() => handleOpenInfoArea(operationData)}
                                                 onMouseEnter={handleShowQuickInfo} onMouseLeave={handleHideQuickInfo}/>
                                            <Popper open={open} anchorEl={anchorEl}
                                                    style={{minWidth: 213, minHeight: 134}} transition placement='top'
                                                    container={document.getElementById("all-operation-eh-log-dialog") ? document.getElementById("all-operation-eh-log-dialog") : document.getElementById("all-operation-log-dialog")}>
                                                {({TransitionProps}) => (
                                                    <ClickAwayListener onClickAway={() => true}>
                                                        <Fade {...TransitionProps} timeout={350}>
                                                            <Paper>
                                                                <div className="all-logs-quick-info-container">
                                                                    <div
                                                                        className="all-logs-quick-info-status-container">
                                                    <span
                                                        className={`all-logs-quick-info-status-text all-log-success`}>
                                                        {t(label + `COMPLETED`)}
                                                    </span>
                                                                    </div>

                                                                    <div className="all-logs-quick-info-start">
                                                                        <div
                                                                            className='all-logs-quick-info-timestamp-header'>
                                                                            <PlayCircleFilledWhiteIcon color='red'
                                                                                                       className='log-action-image'/>
                                                                            <span
                                                                                className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                                                        </div>
                                                                        <span
                                                                            className="time-of-log">{convertToDateFormat(operationData.created_at, personalization.date_format)}</span>
                                                                    </div>
                                                                    <div className="all-logs-quick-info-end">
                                                                        <div
                                                                            className='all-logs-quick-info-timestamp-header'>
                                                                            <img alt="autom-end-icon" src={automEndIcon}
                                                                                 className='log-action-image'/>
                                                                            <span
                                                                                className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                                                                        </div>
                                                                        <span
                                                                            className="time-of-log">{convertToDateFormat(operationData.created_at, personalization.date_format)}</span>
                                                                    </div>
                                                                </div>
                                                            </Paper>
                                                        </Fade>
                                                    </ClickAwayListener>
                                                )}
                                            </Popper>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <div className='empty-page-info-container'>
                                <img alt="empty-page-icon" src={emptyPageIcon}/>
                                <p className='info-text'>{t(label + 'EMPTY-LOGS')}</p>
                            </div>
                    }
                </DialogContent>
            </div>
            {
                isNewLogs && Object.keys(selectedLog).length
                    ?
                    <>
                        <div className="all-logs-details-side-container">
                            <DialogTitle DialogTitle id="alert-dialog-title" >
                                <div id="about-title" className="add-group-header all-logs-header">
                                    <div className="all-logs-details-header-left-side-container">
                                        <div className="all-logs-details-header-title-container">
                                            <img alt="log-webhook-icon" className="all-logs-details-header-action-image" src={LogWebhookIcon} />
                                            -
                                        </div>
                                        <div className="all-logs-time-elapsed-container">
                                            <span className="all-logs-time-elapsed">{t(label + 'TIME-ELAPSED')}</span>
                                            <span className={`log-trigger-param`}>
                                                    0.00 sec
                                                </span>
                                        </div>
                                    </div>
                                    <div className="all-logs-header-right-side-container">
                                        <div className={`all-logs-header-right-info all-log-trigger-param`}>{t(label + `TRIGGER-PARAM`).toUpperCase()}</div>
                                        <Close className="autom-group-close-button logs-close-icon" onClick={() => setSelectedLog({})} style={{ fontSize: "1rem" }} />
                                    </div>
                                </div>
                            </DialogTitle >
                            <DialogContent className="all-logs-details-main-info-container">
                                <div className="all-log-details-timestamps">
                                    <div className="all-log-details-timestamps-start">
                                        <div className="all-logs-details-preview-buttons-container">
                                            <PlayCircleFilledWhiteIcon color='red' className='log-action-image' />
                                            <span className="info-body-row-value">{t(label + `STARTED-AT`)}</span>
                                        </div>
                                        <span className="time-of-log">{convertToDateFormat(selectedLog.created_at, personalization.date_format)}</span>
                                    </div>
                                    <div className="all-log-details-timestamps-end">
                                        <div className="all-logs-details-preview-buttons-container">
                                            <img src={automEndIcon} className='log-action-image' />
                                            <span className="info-body-row-value">{t(label + `ENDED-AT`)}</span>
                                        </div>
                                        <span className="time-of-log">{selectedLog.created_at ? convertToDateFormat(selectedLog.created_at, personalization.date_format) : "-"}</span>
                                    </div>
                                </div>

                                <div className="all-log-details-text-container">
                                    <div className="log-error-header">
                                        <div className='all-logs-details-text-header-row'>
                                            <div className="all-logs-details-preview-buttons-container">
                                                <img alt="log-action-icon" src={findLogIcon("TRIGGER-PARAM")} className='log-action-image' />
                                                <span className={`info-body-row-value all-log-trigger-param`}>{t(label + `TRIGGER-PARAM`)}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="log-error-message">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="all-logs-input-output-container">
                                    <div className="mail-server-text">
                                        <div className="all-log-button-group" style={{ width: "208px"}}>
                                            <div
                                                onClick={() => setType("input")}
                                                className={
                                                    `${type === "input"
                                                        ? "mail-server-button-active"
                                                        : "mail-server-button"
                                                    } user-select-none`}
                                                style={{ width: "100px"}}
                                            >
                                                {t(label + ("TRIGGER-BODY"))}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    if (!operationData?.trigger_header) return
                                                    setType("output")
                                                }}
                                                className={
                                                    `${type === "output"
                                                        ? "mail-server-button-active"
                                                        : "mail-server-button"} user-select-none`
                                                }
                                                style={{ opacity: operationData?.trigger_header ? "1" : "0.5", cursor: operationData?.trigger_header ? "pointer" : "default", width: "100px" }}
                                            >
                                                {t(label + "TRIGGER-HEADER")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {(type === "output" && operationData?.trigger_header)
                                    ? <div className="all-logs-details-preview-input-output-type-container">
                                        <div className='preview-text'> {t(label + `ACTION-TRIGGER-TYPE`)}</div>
                                        <div className="all-logs-input-output-area">
                                            <p>{type === "input" ? t(label + 'OBJECT')
                                                : t(label + 'OBJECT')}</p>
                                        </div>
                                    </div> : ""}
                                <div className="all-logs-details-preview-container">
                                    <div className='preview-text'> {t(label + "PREVIEW")}</div>
                                    <div className={`${loading ? "loading-preview-data-content" : "preview-data-content"} full-height`}>
                                        {loading ? <CircularProgress />
                                            : <>
                                                {type === "input" ? showPreviewData(selectedLog?.trigger_data, "object")
                                                    : selectedLog?.trigger_header ? showPreviewData(selectedLog?.trigger_header, "object") : ""}
                                                {(type === "input" && selectedLog?.trigger_data) || (type === "output" && selectedLog?.trigger_header)
                                                    ? Object.keys(selectedLog.trigger_data).length ? <div className="all-logs-details-preview-buttons-container">
                                                        <Tooltip title={t(label + `COPY`)} placement="top" >
                                                            <FileCopyIcon className='log-json-copy-icon' onClick={(e) => handleCopyInputAndOutput(e, type === "input" ? operationData?.trigger_data : operationData?.trigger_header)} />
                                                        </Tooltip>
                                                        <Tooltip title={t(label + `FULLSCREEN`)} placement="top" >
                                                            <FullscreenIcon className="all-logs-details-preview-fullscreen-button" onClick={(e) => {
                                                                try {
                                                                    let valueType = "empty";
                                                                    let value = "";
                                                                    if (type === "input") {
                                                                        valueType = "object";
                                                                        value = selectedLog?.trigger_data;
                                                                    }
                                                                    else if (selectedLog?.trigger_header) {
                                                                        const logOutput = JSON.parse(selectedLog?.trigger_header)
                                                                        if (logOutput) {
                                                                            valueType = "object"
                                                                            value = selectedLog?.trigger_header
                                                                        }
                                                                        else {
                                                                            value = ""
                                                                        }
                                                                    }
                                                                    setFullScreenValue({ type: valueType, value })
                                                                } catch (error) {
                                                                    console.log("error: ", error)
                                                                }
                                                            }} />
                                                        </Tooltip>
                                                    </div> : "" : ""} </>}
                                    </div>
                                </div>
                            </DialogContent>
                        </div >
                    </> : <></>
            }
            {
                fullScreenValue.type ?
                    <FullScreen title={fullScreenValue.type === "object" ? t(label + `PREVIEW`) : fullScreenValue.type}
                                handleClose={() => setFullScreenValue({type: "", value: ""})}
                                type={fullScreenValue.type ? fullScreenValue.type : "object"}
                                item={fullScreenValue} label={label}>
                        {type === "input"
                            ? <div className={`preview-data-content full-height`}>
                                {showPreviewData(fullScreenValue.value, fullScreenValue.type ? fullScreenValue.type : "object", fullScreenValue.cantParse, "fullScreen")}
                            </div>
                            : <div
                                className={`preview-data-content full-height ${fullScreenValue.type === "data table" ? "preview-data-content-data-table" : ""}`}>
                                {showPreviewData(fullScreenValue.value, fullScreenValue.type, fullScreenValue.cantParse, "fullScreen")}
                            </div>}
                    </FullScreen> : ""
            }
        </Dialog>
    )
}
